import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import { ArrowRight } from "@phosphor-icons/react";

const BG = "/brand/login-hero.jpg";

export default function Login() {
  const { login, loading, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@heroesmigrantes.com");
  const [password, setPassword] = useState("Heroes2026!");

  if (user) {
    navigate("/");
    return null;
  }

  const submit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      toast.success("Bienvenido al Community Engine");
      navigate("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error al ingresar");
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left visual */}
      <div className="hidden lg:flex flex-1 relative overflow-hidden bg-carbon-900">
        <img src={BG} alt="Heroes Migrantes" className="absolute inset-0 w-full h-full object-cover" />
        {/* Soft top gradient para que el tag se lea, sin tapar al héroe */}
        <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-carbon-900/55 to-transparent" />
        <div className="relative z-10 p-10 flex flex-col justify-between text-white w-full">
          <div className="section-label text-white/80">Sistema operativo de comunidad</div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-white/70 self-end bg-carbon-900/30 backdrop-blur px-3 py-1.5 rounded">
            Community Engine
          </div>
        </div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center px-6 py-12 bg-page">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="section-label mb-3">Acceso al panel</div>
          <h2 className="font-heading text-3xl font-medium tracking-tight mb-1">Ingresa a tu cuenta</h2>
          <p className="text-sm text-carbon-500 mb-8">
            Usa tus credenciales de operador para entrar al Community Engine.
          </p>

          <label className="block mb-4">
            <span className="section-label">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="mt-2 w-full bg-white border border-carbon-200 rounded px-3 py-2.5 text-sm focus:outline-none focus:border-terracotta transition-colors"
            />
          </label>

          <label className="block mb-6">
            <span className="section-label">Password</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="mt-2 w-full bg-white border border-carbon-200 rounded px-3 py-2.5 text-sm focus:outline-none focus:border-terracotta transition-colors"
            />
          </label>

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-terracotta text-white py-3 rounded font-medium text-sm hover:bg-terracotta-hover transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? "Ingresando..." : (
              <>
                Entrar al Engine
                <ArrowRight size={16} />
              </>
            )}
          </button>

          <div className="mt-8 p-3 bg-surface-alt rounded text-xs text-carbon-500 leading-relaxed">
            <div className="section-label mb-1">Credenciales de demo</div>
            admin@heroesmigrantes.com / Heroes2026!
          </div>
        </form>
      </div>
    </div>
  );
}
